import React, {createContext, useContext, useState} from "react";
import {getOrders} from "./crud/orderCrud";
import {AutoIncrementer} from "../../../_metronic/_helpers/AutoIncrementer";

const OrdersUIContext = createContext();

export function useOrdersUIContext() {
    return useContext(OrdersUIContext);
}

export function OrdersUIProvider({children}) {

    const [id, setId] = useState(0);
    const [orders, setOrders] = useState([]);
    const [order, setOrder] = useState({});
    const [openDelete, setOpenDelete] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const fetchData = () => {
        getOrders()
            .then((response) => {
                setOrders(AutoIncrementer(response.data.data.data));
            });
    };

    const handleDelete = id => {
        setOpenDelete(true);
        setId(id);
    };

    const value = {
        orders,
        setOrders,
        order,
        setOrder,
        openError,
        setOpenError,
        error,
        setError,
        openDelete,
        setOpenDelete,
        id,
        setId,
        handleDelete,
        fetchData,
    };

    return <OrdersUIContext.Provider value={value}>{children}</OrdersUIContext.Provider>;
}